class SetReferenzenFilter { 
	constructor() {
		this.navBtns = document.querySelectorAll('#tabs-nav .btn');
		this.contentItems = document.querySelectorAll('#tabs-content > .referenzen__imagetabs');
		this.itemsToShow = [];
		this.currentFilter = 'all';
		this.init()
	}
	init() { 
		this.eventListeners();
	}

	eventListeners() { 
		this.navBtns.forEach((btn) => {
			btn.addEventListener('click', (e) => {
				this.currentFilter = e.target.dataset.id;
				this.navBtns.forEach((btn) => btn.classList.remove('active'))
				btn.classList.add('active');
				this.filterItems();
				console.log(this.itemsToShow)
			})
		})
	}

	filterItems() { 
		this.itemsToShow = [];
		this.contentItems.forEach((item) => {
			if (this.currentFilter === 'all') {
				this.itemsToShow.push(item);
			} else if (item.classList.contains(this.currentFilter)) {
				this.itemsToShow.push(item);
			}
		})
		this.renderItems()
	}
	renderItems() {
		let index = 1
		const mediumIndices = [2,3,5,7,11]
		let mediumIndex = index

		this.contentItems.forEach((item) => {
			item.classList.remove('active');
			item.classList.remove('large');
			item.classList.remove('medium');
		})

		this.itemsToShow.forEach((item) => {
			if ((index - 1) % 12 === 0) { 
				item.classList.add('large');
				mediumIndex = 1
			}
			if (mediumIndices.includes(mediumIndex)) {
				item.classList.add('medium');
			}
			item.classList.add('active');
			index++
			mediumIndex++
		}
		)
	 }
}

window.addEventListener('load', () => {
	if (document.querySelector('#tabs-nav .btn')) {
		const referenzenFilter = new SetReferenzenFilter();
	}
 })

